import dotenv from 'dotenv';

dotenv.config();

export const serviceHost =
  `/${process.env.REACT_APP_API_VERSION}` || '';

export const appHost = process.env.REACT_APP_HOST;
